import { render, staticRenderFns } from "./BankEditor.vue?vue&type=template&id=04885c80"
import script from "./BankEditor.vue?vue&type=script&lang=js"
export * from "./BankEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports